import { SmartCheckbox } from 'app/components/shared/FormComponents/SmartCheckbox'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Location } from 'EstraSponsor'
import React from 'react'
import { useFormContext } from 'react-hook-form'

import { UserRegistrationFormData } from '../../../formTypes'
import { HolderFormSection } from '../Holder'

type Props = {
  locations: Location[]
  checkboxText: string
  holderWho: keyof Pick<
    UserRegistrationFormData,
    'technical_director_address' | 'technical_manager_address'
  >
  checkboxFor: keyof Pick<
    UserRegistrationFormData,
    'fill_technical_director' | 'fill_technical_manager'
  >
}

export const HolderWrapper = ({
  locations,
  checkboxText,
  holderWho,
  checkboxFor,
}: Props): JSX.Element => {
  const { watch } = useFormContext()
  const checkboxWatcher = watch(checkboxFor)

  return (
    <>
      <FormGroup>
        <SmartCheckbox reverseBehaviour name={checkboxFor}>
          {checkboxText}
        </SmartCheckbox>
      </FormGroup>
      {checkboxWatcher && (
        <HolderFormSection holderWho={holderWho} locations={locations} />
      )}
    </>
  )
}
